export default {
  archiveDuration: 'Délka archivu',
  broadcastsAssignable: 'Navazovat',
  broadcastingFrom: 'Vysílání od',
  broadcastingTo: 'Vysílání do',
  cast: 'Hrají/Účinkují',
  country: 'Země',
  csfdLink: 'ČSFD link',
  dataSource: 'Zdroj dat',
  description: 'Popis',
  directors: 'Režie',
  duration: 'Stopáž',
  email: 'Email',
  episodeNumber: 'Číslo epizody',
  EPGProcessingEnd: 'Konec zpracování EPG',
  firstName: 'Jméno',
  groupOrder: 'Pořadí ve skupině',
  hasParentLock: 'Rodičovský zámek',
  imdbLink: 'IMDb link',
  importDuration: 'Délka zobrazovaného importu',
  importId: 'Importní ID',
  isPeriodic: 'Periodický',
  isTest: 'Testovací',
  isHD: 'HD Kanál',
  is4netAvailable: 'V nabídce 4NET',
  isCzech: 'Česky',
  isoCode: 'ISO kód',
  lastName: 'Příjmení',
  leadParagraph: 'Perex',
  lockedFrom: 'Zamčeno od',
  lockedTo: 'Zamčeno do',
  show: 'Pořad',
  name: 'Název',
  note: 'Poznámka',
  order: 'Pořadí',
  orderInStation: 'Pořadí ve stanici',
  originalName: 'Originální název',
  password: 'Heslo',
  position: 'Pozice',
  poster: 'Poster',
  photo: 'Fotka',
  rating: 'Hodnocení',
  sanitizedId: 'Sanitizovaný tvar',
  templateExpression: 'Šablona',
  type: 'Typ',
  tvStation: 'TV stanice',
  tvStationGroupId: 'Skupina',
  seriesNumber: 'Číslo série',
  username: 'Přihlašovací jméno',
  weight: 'Váha',
  yearStart: 'Rok výroby',
  yearEnd: 'Rok ukončení',
  youtubeLink: 'Trailer'
}
